import React, { useState } from 'react';
import Toolbar from './Toolbar';
import LeftSidebar from './LeftSidebar';
import RightSidebar from './RightSidebar';
import Workspace from './Workspace';

const EditorLayout = () => {
  const [showLeftSidebar, setShowLeftSidebar] = useState(true);
  const [showRightSidebar, setShowRightSidebar] = useState(true);

  const toggleLeftSidebar = () => {
    setShowLeftSidebar(!showLeftSidebar);
  };

  const toggleRightSidebar = () => {
    setShowRightSidebar(!showRightSidebar);
  };

  return (
    <div className="editor-layout">
      <Toolbar />
      <div className="wrap">
        {/* Single toggle button for left sidebar */}
        <button 
          className="sidebar-toggle left-toggle" 
          onClick={toggleLeftSidebar}
          style={{
            position: 'fixed',
            top: 'calc(50px + 64px + 20px)', // Navbar(50) + Toolbar(64) + offset
            left: showLeftSidebar ? '240px' : '0',
            zIndex: 950,
            background: '#1ca29b',
            color: 'white',
            border: 'none',
            borderRadius: '0 4px 4px 0',
            width: '24px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'left 0.3s ease'
          }}
        >
          <i className={`fas ${showLeftSidebar ? 'fa-chevron-left' : 'fa-chevron-right'}`}></i>
        </button>
        
        {/* Single toggle button for right sidebar */}
        <button 
          className="sidebar-toggle right-toggle" 
          onClick={toggleRightSidebar}
          style={{
            position: 'fixed',
            top: 'calc(50px + 64px + 20px)', // Navbar(50) + Toolbar(64) + offset
            right: showRightSidebar ? '280px' : '0',
            zIndex: 950,
            background: '#1ca29b',
            color: 'white',
            border: 'none',
            borderRadius: '4px 0 0 4px',
            width: '24px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'right 0.3s ease'
          }}
        >
          <i className={`fas ${showRightSidebar ? 'fa-chevron-right' : 'fa-chevron-left'}`}></i>
        </button>

        {showLeftSidebar && <LeftSidebar />}
        
        <Workspace 
          showLeftSidebar={showLeftSidebar}
          showRightSidebar={showRightSidebar}
        />
        
        {showRightSidebar && <RightSidebar />}
      </div>
    </div>
  );
};

export default EditorLayout;